import styled, { createGlobalStyle } from 'styled-components';
import { COLORS } from '../../../utils/theme/colors';

export const ScopedStyle = createGlobalStyle`
  .ktULCB {
    padding-bottom: 0px !important;
  }
  .jThucN {
    padding-bottom: 0px !important;
  }
`;

export const Div = styled.div`
  position: relative;
  font-weight: 500;

  .header_row {
    display: flex;
    flex-direction: column;
    margin: 20px 2% 0 2%;
    width: 96%;
  }

  .top-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 12px;
    margin-bottom: 10px;
  }

  .bottom-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
  }

  .controls-group {
    display: flex;
    align-items: center;
    gap: 3px;
  }

  .page_title {
    margin: 0;
    font-size: 23px;
    color: #777;
  }

  .date-range-label {
    color: ${({ theme }) => theme.primary};
    font-size: 23px;

    &.info-text {
      font-size: 15px;
      align-self: center;
    }
  }

  .range_picker {
    border: none;
    border-radius: 8px;
    background-color: #fff !important;
    height: 38px;
    width: 230px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
  }

  .range_picker:hover {
    cursor: pointer;
    border: none;
    box-shadow: 0 0 4px -1px rgba(0, 0, 0, 0.1);
  }

  .range_picker .ant-picker-input > input {
    background-color: #fff !important;
  }

  .error_message {
    color: red;
    margin-left: 2%;
    margin-top: 16px;
  }

  .content {
    margin: 20px;
    margin-top: 18px;
    background: #f7f7f7;
    padding: 13px 15px;
    border-radius: 6px;
    max-height: calc(100vh - 230px);
    overflow: auto;
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);

    &::-webkit-scrollbar {
      width: 8px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f7f7f7;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.primary};
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      cursor: pointer;
    }

    &::-webkit-scrollbar-corner {
      background: #f7f7f7;
    }
  }

  .pagination-bar {
    display: flex;
    justify-content: center;
    margin: 0px !important;
  }
`;

export const ButtonHeader = styled.button`
  background-color: ${COLORS.transparentDark};
  padding: 10px 30px;
  margin-left: 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #444;
  text-decoration: none;
  transition: background-color 200ms ease-in-out;
  border: none;

  &:hover {
    background-color: ${({ theme }) => theme.hoveredDiv};
    color: ${COLORS.primary};
    cursor: pointer;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(3px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  .box {
    background: white;
    padding: 30px 40px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    .overlay-text {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
    }

    .dates {
      font-size: 16px;
      font-weight: bold;
      color: ${({ theme }) => theme.primary};
      margin: 0;
    }

    .message {
      font-size: 16px;
      color: #555;
      margin: 0;
    }
  }
`;
